<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout v-if="Boolean(selectedCompany)" align-center row>
      <v-spacer />

      <a
        v-if="hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES') && activeTab === 0"
        href="#"
        :title="$t(`${namespace}.actionBar.export`)"
        class="action-bar__link"
        @click.prevent="handleExportAllIncentives"
      >
        {{ exportIsLoading ? $t(`${namespace}.actionBar.exportIsLoading`) : $t(`${namespace}.actionBar.export`) }}
      </a>

      <v-btn
        v-if="
          hasRole('billing', 'ROLE_POST_INCENTIVE_UPLOAD') &&
          hasRole('billing', 'ROLE_GET_INCENTIVE_UPLOAD') &&
          hasRole('billing', 'ROLE_PATCH_INCENTIVE_PENDING_TO_APPROVAL')
        "
        :to="{ name: 'IncentivesBulkOperation' }"
        color="accent"
        class="action-bar__btn"
        round
        depressed
      >
        {{ $t(`${namespace}.bulkImport`) }}
      </v-btn>
    </v-layout>
  </v-toolbar>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { isArray, hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  props: {
    activeTab: {
      type: Number
    },
    filters: {
      type: Object
    }
  },
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.IncentivesPage',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'Incentives', title: this.$t('Views.IncentivesPage.title') }
      ],
      exportIsLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    downloadXLSXfile (res) {
      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const url = window.URL.createObjectURL(blob)
      const $link = document.createElement('a')
      const date = moment().format('YYYYMMDD')

      $link.href = url
      $link.setAttribute('download', `incentivos-${date}.xlsx`)
      document.body.appendChild($link)
      $link.click()
      $link.remove()
    },

    async handleExportAllIncentives () {
      this.exportIsLoading = true

      try {
        const { data: res } = await this.$apiService.incentives.export()
        this.downloadXLSXfile(res)
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : this.$t('Common.genericErrorMsg')
        this.showAlert({ type: 'error', message })
      }

      this.exportIsLoading = false
    }
  }
}
</script>
